import { call, put, takeEvery, take, select } from "redux-saga/effects";
import { eventChannel, END } from "redux-saga";
import { getProvider } from "@/providers";
import { getExpirationDate } from "@/helpers/date_helper";
/* Selector */
import { selectSignsByKey } from "./selectors";
// Redux Actions
import { ETH_PLAIN_SIGN_PROCESSED, ETH_EIP_712_SIGN_PROCESSED, ETH_EIP_712_SIGN_FAILED } from "@ensuro/ethereum-store";
import { SET_PROVIDER, SET_CHAIN_ID, SET_USER, SET_KYC_SIGNATURE } from "./actionTypes";
import { kycIframe } from "@/config";

function providerListenerChannel(provider) {
  return eventChannel((emitter) => {
    /*if (provider.removeAllListeners)
      provider.removeAllListeners();*/
    provider.on("accountsChanged", (evtData) => {
      // Track Wallet can't emit this event, so it's always true
      emitter({ type: SET_USER, payload: evtData[0], canTransact: true });
    });

    provider.on("chainChanged", (evtData) => {
      emitter({ type: SET_CHAIN_ID, payload: Number(evtData?.id ?? parseInt(evtData, 16)) });
    });

    provider.on("disconnect", () => {
      emitter({ type: SET_PROVIDER, payload: null });
      emitter(END);
    });
    return () => {};
  });
}

export function* listenToEvents({ payload }) {
  if (payload == null) return;
  const provider = getProvider(payload);
  // Providers without event support (e.g. read-only Track Wallet) skip subscription
  if (typeof provider?.on !== "function") return;
  const channel = yield call(providerListenerChannel, provider);
  try {
    while (true) {
      let action = yield take(channel);
      yield put(action);
    }
  } finally {
    // Cleanup if needed
  }
}

export function* storeUser({ key, userAddress, signature, message }) {
  const state = yield select((state) => state.UserReducer);
  const sign = selectSignsByKey(state, key, userAddress);
  if (userAddress !== state.address) {
    // We want to ignore any call made by another address than the state one.
    return;
  }
  const args = sign.args;

  const kycSignature = {
    message: message,
    signature: signature,
    address: state.address,
    chainId: state.chainId,
    expiration: getExpirationDate(),
    email: args.email,
  };

  yield put({ type: SET_KYC_SIGNATURE, kycSignature });
}

export function bridgeEip712ToIframe(action) {
  const signValue = action.value || {};

  if (signValue.newWallet) {
    const iframes = Array.from(document.querySelectorAll("iframe"));

    const targetIframe = iframes.find((iframe) => iframe.title === "Ensuro KYC" || iframe.title === "KYC");

    if (targetIframe && targetIframe.contentWindow) {
      const payloadForIframe = {
        ...action,
        key: `walletLink_${signValue.newWallet}`,
      };

      const iframeOrigin = kycIframe.allowAnyOrigin ? "*" : new URL(kycIframe.url).origin;
      targetIframe.contentWindow.postMessage(payloadForIframe, iframeOrigin);
    }
  }
}
export function bridgeEip712FailureToIframe(action) {
  const iframes = Array.from(document.querySelectorAll("iframe"));

  const targetIframe = iframes.find((iframe) => iframe.title === "Ensuro KYC" || iframe.title === "KYC");

  if (targetIframe && targetIframe.contentWindow) {
    const iframeOrigin = kycIframe.allowAnyOrigin ? "*" : new URL(kycIframe.url).origin;
    targetIframe.contentWindow.postMessage(action, iframeOrigin);
  }
}

export function* userSaga() {
  yield takeEvery(SET_PROVIDER, listenToEvents);
  yield takeEvery(ETH_PLAIN_SIGN_PROCESSED, storeUser);
  yield takeEvery(ETH_EIP_712_SIGN_PROCESSED, bridgeEip712ToIframe);
  yield takeEvery(ETH_EIP_712_SIGN_FAILED, bridgeEip712FailureToIframe);
}

export default userSaga;
